export default {
    groupName: 'comcast-smb',
    appName: 'Comcast Business',
    baseRoute: '/dashboard/comcast-smb',
    label: 'Ad Effect Dashboard',
    home: '/slicer',
    image: 'dummy-2.png',
    description: 'Comcast Business Ad Effect Dashboard'
}


// WEBPACK FOOTER //
// ./src/app/configuration/ComcastSMB/config/main.js